module.exports = __webpack_public_path__ + "img/secadora.70c05747.svg";